import { MemoryOutputStream } from "./memory-output-stream.js";
import { MemoryInputStream } from "./memory-input-stream.js";
export class MemoryStreamDictionary {
    contentMap = {};
    readPath(path) {
        const content = this.contentMap[path] ?? "";
        return new MemoryInputStream(content);
    }
    writePath(path) {
        return new MemoryOutputStream((stream) => {
            this.contentMap[path] = stream.getContent();
        });
    }
    async exists(path) {
        return this.contentMap[path] !== undefined;
    }
    async list() {
        return [...Object.keys(this.contentMap)];
    }
}
//# sourceMappingURL=memory-stream-dictionary.js.map